<template>
    <div class="progress-container vertical">
        <div class="progress-head">
            <span class="progress-label">{{ label }}</span>
            <span v-if="!indeterminate" class="progress-percent">{{ percent.toFixed(0) }}%</span>
        </div>
        <!-- Drawn with plain divs instead of <progress>: every engine (and Brave's
             Chromium build on macOS) renders the native element with its own
             theme, and the vendor pseudo-elements needed to restyle it differ. -->
        <div
            class="crfi-progress"
            role="progressbar"
            aria-valuemin="0"
            :aria-valuemax="indeterminate ? null : total"
            :aria-valuenow="indeterminate ? null : loaded"
        >
            <div v-if="indeterminate" class="crfi-progress-bar indeterminate"></div>
            <div v-else class="crfi-progress-bar" :style="{ width: percent + '%' }"></div>
        </div>
    </div>
</template>

<script>
const BYTES_PER_MB = 1048576;

export default {
    name: 'ProgressBar',
    props: {
        loaded: {
            type: Number,
            default: 0
        },
        total: {
            type: Number,
            default: 0
        }
    },
    computed: {
        indeterminate() {
            return !(this.total > 0);
        },
        percent() {
            if (this.indeterminate) return 0;
            return Math.min(100, (this.loaded / this.total) * 100);
        },
        label() {
            if (this.indeterminate) {
                // Size unknown: show what we have, or "Preparing" before any bytes.
                return this.loaded > 0 ? `${this.toMB(this.loaded)} MB` : this.$t('Preparing');
            }
            return `${this.toMB(this.loaded)} MB / ${this.toMB(this.total)} MB`;
        }
    },
    methods: {
        toMB(bytes) {
            return (bytes / BYTES_PER_MB).toFixed(2);
        }
    }
}
</script>

<style scoped>
.progress-container {
    margin: 10px 20px;
}

.progress-head {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 6px;
    font-size: 14px;
    color: #414F51;
}

.progress-percent {
    font-weight: 600;
    color: #356C88;
}

.crfi-progress {
    position: relative;
    width: 100%;
    height: 12px;
    border-radius: 6px;
    background-color: #e3ebee;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

.crfi-progress-bar {
    height: 100%;
    border-radius: 6px;
    background-color: #356C88;
    transition: width 0.2s linear;
}

.crfi-progress-bar.indeterminate {
    position: absolute;
    left: 0;
    top: 0;
    width: 40%;
    animation: crfi-progress-indeterminate 1.4s ease-in-out infinite;
}

@keyframes crfi-progress-indeterminate {
    from { transform: translateX(-100%); }
    to { transform: translateX(250%); }
}
</style>



// WEBPACK FOOTER //
// src/components/ProgressBar.vue